module.exports = __webpack_public_path__ + "img/default_personnel.17c331ec.png";